import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerReservationDataProvider')
export class CustomerReservationDataProvider extends AbstractDataProviderV2<any> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/reservation/customers/{id}/actualize');
    }

    public update(resourceParams) {
        const url = this.getResourceUrl(resourceParams);
        return this.service.updateRequest<any>(url, 'PUT');
    }
}
